module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner",
    class: {
      inline: _vm.inline, main: !_vm.inline
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-4x"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb1af4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
// module id = 274
// module chunks = 0